export default __webpack_public_path__ + "static/media/01.a3ff22de.jpg";